import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { UserRoles } from '../dictionaries/UserRoles';

const ALLOWED_ROLES = [UserRoles.owner, UserRoles.admin];

/**
 * Allows facility owners and admins (both Hub and Spoke) to access the
 * merge cases review page. The component itself scopes results by facility.
 */
@Injectable({
  providedIn: 'root'
})
export class MergeCasesGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.userData.pipe(
      filter((user: any) => !!(user?.role || user?.realRole)),
      take(1),
      map((user: any) => {
        const role = user.realRole ?? user.role;
        const hasFacility = !!(user.facility || '').trim();
        if (ALLOWED_ROLES.includes(role) && hasFacility) {
          return true;
        }
        return this.router.createUrlTree(['/']);
      })
    );
  }
}
